import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Trans, useTranslation } from "react-i18next";
import cookie from "SharedImages/cookie-icon.png";
import logo from "SharedImages/tuutuum-logo-black.png";
import CookieCategories from "./CookieCategories";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    } else {
      setIsMinimized(true);
    }
  }, []);

  const handleAcceptAll = () => {
    Cookies.set(
      "cookieConsent",
      JSON.stringify({
        necessary: true,
        functional: true,
        marketing: true,
        analytics: true,
      }),
      { expires: 365 }
    );
    setIsVisible(false);
    setIsMinimized(true);
  };

  const handleAcceptNecessary = () => {
    Cookies.set("cookieConsent", JSON.stringify({ necessary: true }), {
      expires: 365,
    });
    setIsVisible(false);
    setIsMinimized(true);
  };

  // Minimize the banner = accept all cookies
  const handleMinimize = () => {
    handleAcceptAll();
  };

  // Show minimized banner
  if (isMinimized && !isVisible) {
    return (
      <div className="fixed flex flex-row bottom-0 left-0 bg-teal-100 z-50 shadow-lg rounded-tr-lg p-2 items-center justify-center">
        <button
          className="flex flex-row items-center justify-center text-purple font-semibold text-xs hover:text-black"
          onClick={() => {
            setIsVisible(true);
            setIsMinimized(false);
          }}
        >
          <img
            src={cookie}
            alt="Cookie Icon"
            className="w-3.5 h-3.5 float-left mr-1"
          />
          {t("cookie_banner.manage_cookies")}
        </button>
      </div>
    );
  }

  if (!isVisible) return null;

  return (
    <div className="fixed max-h-screen bottom-0 left-0 right-0 bg-teal-100 z-50 shadow-2xl rounded-xl md:w-4/5 xl:w-2/5 m-5 lg:ml-10 lg:mb-10 text-xs md:text-sm">
      <div className="flex flex-col mx-auto">
        <div className="flex flex-row items-center mx-5 py-3 min-w-auto">
          <div className="w-full flex justify-between">
            <img
              src={cookie}
              alt="Cookie Icon"
              className="w-8 h-8 float-left"
            />
            <button
              className="text-purple font-black hover:text-black text-xl"
              onClick={handleMinimize}
              aria-label={t("cookie_banner.minimize")}
            >
              x
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex font-semibold border-t-2 border-teal-300 ">
          <button
            className={`flex-1 py-3 text-center uppercase ${
              activeTab === 1
                ? "text-purple border-b-2 border-purple"
                : "text-black border-b-2 border-teal-300"
            }`}
            onClick={() => setActiveTab(1)}
          >
            {t("cookie_banner.tabs_consent")}
          </button>
          <button
            className={`flex-1 py-3 text-center uppercase ${
              activeTab === 2
                ? "text-purple border-b-2 border-purple"
                : "text-black border-b-2 border-teal-300"
            }`}
            onClick={() => setActiveTab(2)}
          >
            {t("cookie_banner.tabs_information")}
          </button>
          <button
            className={`flex-1 py-3 text-center uppercase ${
              activeTab === 3
                ? "text-purple border-b-2 border-purple"
                : "text-black border-b-2 border-teal-300"
            }`}
            onClick={() => setActiveTab(3)}
          >
            {t("cookie_banner.tabs_about")}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 1 && (
          <div className="px-8 py-6 bg-white">
            <p>
              <Trans
                i18nKey="cookie_banner.consent_text"
                components={{
                  a: <a href={`/terms#${t("hashes.privacy")}`} />,
                }}
              >
                {t("cookie_banner.consent_text")}
              </Trans>
            </p>
          </div>
        )}

        {activeTab === 2 && <CookieCategories t={t} />}

        {activeTab === 3 && (
          <div className="px-8 py-6 bg-white">
            <p>
              <Trans
                i18nKey="cookie_banner.about_text"
                components={{
                  a: <a href={`/terms#${t("hashes.privacy")}`} />,
                }}
              >
                {t("cookie_banner.about_text")}
              </Trans>
            </p>
          </div>
        )}

        {/* Buttons */}
        <div className="flex flex-col md:flex-row px-6 border-t-2 border-teal-300 space-y-2 md:space-x-4 md:space-y-0 py-4">
          <button
            className="md:flex-1 border-2 border-purple hover:border-teal-600 text-black px-4 py-2 rounded-lg font-semibold"
            onClick={handleAcceptNecessary}
          >
            {t("cookie_banner.accept_necessary")}
          </button>
          <button
            className="md:flex-1 border-2 border-purple hover:border-teal-600 text-black px-4 py-2 rounded-lg font-semibold"
            onClick={() => setActiveTab(2)}
          >
            {t("cookie_banner.customize")}
          </button>
          <button
            className="md:flex-1 bg-purple hover:bg-teal-800 text-white px-4 py-2 rounded-lg font-bold"
            onClick={handleAcceptAll}
          >
            {t("cookie_banner.accept_all")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
